import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_TESORERIA_MOVEMENTS;

//Con el filtro raw en true el listado devuelve filas planas resueltas por SQL, sin objetos de Doctrine
function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get/" + param.id, param);
}

function balanceByAccount(param = {}) {
  return wsService.make_post_request(section + "/balance_by_account", param);
}

function revert(id, param = {}) {
  return wsService.make_post_request(section + "/revert/" + id, param);
}

export const tesoreriaMovementService = {
  section,
  filter,
  get,
  remove,
  create,
  update,
  balanceByAccount,
  revert,
};
